import styled from 'styled-components';
import { PaperContainer, colors } from '../../healtheraComponents';
import Switch from '../Shared/Switch';
import { Cancel } from '@material-ui/icons';

export const StyledLoadingContainer = styled.div`
  margin-top: 200px;
  display: flex;
  justify-content: center;
`;

export const StyledContainer = styled.div``;

export const StyledHeaderContainer = styled.header`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledErrorTextContainer = styled.div`
  display: flex;
  align-items: flex-end;
  margin-right: 10px;
`;

export const StyledPaperContainer = styled(PaperContainer)`
  && {
    width: 100%;
    box-sizing: border-box;
    box-shadow: none;
  }
`;

export const StyledTextButton = styled.button`
  color: ${colors.HEALTHERA_GREEN};
  background: none;
  cursor: pointer;
  border: none;

  opacity: 1;
  transition: opacity 0.2 ease;

  &:hover {
    opacity: 0.7;
  }
`;

export const Row = styled.div`
  display: flex;
  gap: 20px;
  margin: 20px 0;
`;

export const StyledSwitch = styled(Switch).attrs({
  withPadding: false,
  reverseOrder: true,
})``;

export const StyledSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledSectionTitle = styled.h3`
  margin: 0;
  font-size: 18px;
`;

export const StyledHidingContainer = styled.div<{ hide?: boolean }>`
  ${(props) => props.hide && 'display: none;'}
`;

export const Columns = styled.div`
  display: flex;
  gap: 20px;
`;

export const StyledFormContainer = styled.div`
  margin-top: 10px;
  flex-grow: 1;
`;

export const StyledSectionSubtitle = styled.p`
  margin: 0;
  margin-top: 10px;
  font-size: 14px;
`;

export const StyledCancelIcon = styled(Cancel)`
  color: ${colors.FADED};
  cursor: pointer;

  opacity: 1;

  && {
    transition: opacity 0.3s ease;
  }

  &:hover {
    opacity: 0.7;
  }
`;

export const StyledFirstColumn = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StyledSecondColumn = styled.div`
  width: 480px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
